import { mapActions, mapState, mapMutations } from "vuex";

import Util from "../../util/funcoes";

export default {
  props: {
    isFullSize: Boolean
  },
  
  data() {
    return {
      isLoading: false,
      isShowAlugueisMesAnterior: false,
      visibilidadeAlugueisAtrasados: true,
      visibilidadeAlugueisMesAnterior: false,

      payload: {
        dataVencimentoInicio: Util.recuarPeriodoDaData(Util.stringParaData(Util.primeiroDiaMes()), 1),
        dataVencimentoFim: Util.recuarPeriodoDaData(Util.stringParaData(Util.ultimoDiaMes()), 1) 
      }
    };
  },

  created() {
    this.listar();
  },

  computed: {
    ...mapState('alugueisAtrasadosStore', {
      alugueisAtrasados(state) { return state.listaAlugueisAtrasados },
      alugueisAtrasadosMesAnterior(store) { return store.listaAlugueisAtrasadosMesAnterior }
    }),

    tooltipQuantidadeAlugueisIsVisible() {
      return this.alugueisAtrasados.length > 0;
    },
    quantidadeAlugueis() {
      const quantidade = this.alugueisAtrasados.length;
      switch (quantidade) {
        case 1:
          return 'Exibindo 1 Aluguel';
      
        default:
          return `Exibindo ${quantidade} Aluguéis`;
      }
    },

    quantidadeAlugueisMesAnterior() {
      const quantidade = this.alugueisAtrasadosMesAnterior.length;
      switch (quantidade) {
        case 1:
          return 'Exibindo 1 Aluguel';
      
        default:
          return `Exibindo ${quantidade} Aluguéis`;
      }
    },
  },

  watch: {
    'isShowAlugueisMesAnterior': function (newValue, oldValue) {
      if(newValue != oldValue) {
        if(newValue === true) {
          this.listarMesAnterior(this.payload);
          this.visibilidadeAlugueisAtrasados = false;
          this.visibilidadeAlugueisMesAnterior = true;
        } else {
          this.visibilidadeAlugueisAtrasados = true,
          this.visibilidadeAlugueisMesAnterior = false
        }

      }
    }
  },
  
  methods: {
    ...mapMutations('alugueisAtrasadosStore', [
      'limparAlugueis',
      'limparAlugueisMesAnterior'
    ]),
    ...mapActions('alugueisAtrasadosStore', [
      'recuperarAlugueisAtrasados',
      'recuperarAlugueisMesAnterior'
    ]),

    listar() {
      this.showLoading();
      this.limparAlugueis();
      this.recuperarAlugueisAtrasados()
        .then()
        .finally(() => {
          this.hideLoading();
        });
    },

    listarMesAnterior(payload) {
      this.showLoading();
      this.limparAlugueisMesAnterior();
      this.recuperarAlugueisMesAnterior(payload)
        .then()
        .finally(() => {
          this.hideLoading();
        });
    },

    showLoading() {
      this.isLoading = true;
    },
    hideLoading() {
      this.isLoading = false;
    },

    formatarLabelValor(item) {
      return Util.formatarValor(item.valor);
    },

    
  },
};